import React from 'react';
import ReactDOM from 'react-dom/client';

import App from 'app/App';
import { initMonitoring } from 'services/monitoring';
import 'index.css';
import reportWebVitals from './reportWebVitals';

// Before the first render, so a crash during boot is still reported. No-op
// until REACT_APP_SENTRY_DSN is set.
initMonitoring();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
